import { featureFlipping } from '@headless-workspace/config';
import { UrlHelpers } from '@headless-workspace/utils';
import { BreadcrumbDTO } from './BreadcrumbDTO';

export type BreadcrumbValue = Readonly<{
    id: string;
    label: string;
    tcDisplayName: string;
    url: string;
}>[];

export const mapBreadcrumbValue = (breadcrumbs: BreadcrumbDTO[]): BreadcrumbValue => {
    return breadcrumbs.map(({ id, label, link, tcDisplayName = '' }) => ({
        id,
        label,
        tcDisplayName,
        url: featureFlipping.isDiscoverBreadcrumbShortUrlsEnabled ? UrlHelpers.getHrefPathname(link) : link,
    }));
};
